import Vue from 'vue';
import draggable from 'vuedraggable';
Vue.component('draggable', draggable);
